import { render, staticRenderFns } from "./TrainingPlans.vue?vue&type=template&id=6f753cae&"
import script from "./TrainingPlans.vue?vue&type=script&lang=js&"
export * from "./TrainingPlans.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports